import { FC, useCallback, useEffect, useState } from "react"
import { FilterProps } from "./Filter.types"
import { StyleSheet, Text, TouchableOpacity, View } from "react-native"
import { COLORS, FONTS } from "../../constants"
import { STYLE_VARS } from "../../constants/style-vars"
import { IEventCategory } from "../../types"
import { useDispatch } from "react-redux"
import { SubFilter } from "./components"
import { decode } from 'html-entities';
import { Category } from "../../types/categories.types"

const Filter: FC<FilterProps> = ({
    categoriesData,
    getData,
    filterData,
    setFilterData,
    setData,
    filterSelected,
    setFilterSelected,
  }) => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [slugSelected, setSlugSelected] = useState<string[]>([]);
  //const [filterSelected, setFilterSelected] = useState<Category[]>([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setSlugSelected(filterSelected.map(item => item.slug));
  }, [filterSelected])

  const handleCategoriesData = (categoriesData: IEventCategory[]) => {
    const data = categoriesData;
    let categoriesList: Category[] = [];
    for (let i = 0; i < data.length; i++) {
      let categoriesItem: Category = {
        ...data[i],
        child: [],
      };
      if (categoriesItem.parent === 0) {
        categoriesItem.child = data.filter((e) => e.parent === categoriesItem.id);
        categoriesList.push(categoriesItem);
      }
    }

    setCategories(categoriesList);
  }

  const handleFilterSelect = useCallback(
    (selected: Category) => {
      if (slugSelected.includes(selected.slug)) {
        const arr = filterSelected.filter((filter) => filter.slug !== selected.slug);
        setFilterSelected(arr);
      } else {
        const arr = [...filterSelected, selected];
        setFilterSelected(arr);
      }
    },
    [filterSelected, setFilterSelected, slugSelected]
  );

  const handleFilterReset = useCallback(() => {
    setFilterSelected([]);
    getData({
      ...filterData,
      cats: '',
      page: 1,
    });
    dispatch(
      setFilterData({
        ...filterData,
        cats: '',
        page: 1,
      })
    );
  }, [getData, filterData, dispatch, setFilterData, setFilterSelected]);

  useEffect(() => {
    handleCategoriesData(categoriesData);
  }, [categoriesData])

  useEffect(() => {
    const filters = filterSelected.filter(
      (filter) => !filter.child || filter.child.length === 0
    );
    const slugArray = filters.map((obj) => obj.slug);
    const resultString = slugArray.join(',');
    if (resultString !== filterData.cats) {
      dispatch(setData([]));
      getData({
        ...filterData,
        cats: resultString,
        page: 1,
      });
      dispatch(
        setFilterData({
          ...filterData,
          cats: resultString,
          page: 1,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterSelected, dispatch, getData, setData, setFilterData]);

  return (
    <View style={{
      flexDirection: 'row',
    }}>
      <View style={{
        width: '70%',
      }}>
        <View style={{
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}>
          {categories.map((category) => (
            <TouchableOpacity
              key={category.id}
              style={[styles.selectWrapper, { alignSelf: 'flex-start' }]}
              onPress={() => handleFilterSelect(category)}
            >
              <View style={styles.selectedBox}>
                {slugSelected.includes(category.slug) && (
                  <View
                    style={{
                      width: '100%',
                      height: '100%',
                      borderColor: STYLE_VARS.primaryColor,
                      borderWidth: 4,
                    }}
                  ></View>
                )}
              </View>
              <Text style={styles.selectedText}>{decode(category.name)}</Text>
            </TouchableOpacity>
          ))}
        </View>
        {filterSelected.map((selected) => {
          if (selected.child && selected.child.length > 0) {
            return (
              <View style={{flexDirection: 'row'}} key={selected.name}>
                <SubFilter
                  selectedFilter={selected}
                  handleSubFilterSelect={handleFilterSelect}
                  filterSelected={filterSelected}
                />
              </View>
            )
          }
        })}
      </View>
      <View style={{
        width: '30%',
        flexDirection: 'row',
        justifyContent: 'flex-end',
      }}>
        <TouchableOpacity
          onPress={handleFilterReset}
        >
          <Text style={{
            fontSize: 12,
            fontFamily: FONTS.AvenirMedium,
            color: COLORS.GREEN,
            fontWeight: '500',
            textTransform: 'uppercase',
          }}>RESET FILTER</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}

export default Filter

const styles = StyleSheet.create({
  selectWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
    marginEnd: 12,
  },
  selectedBox: {
    width: 14,
    height: 14,
    borderWidth: 1,
    borderColor: COLORS.GREEN,
    borderRadius: 2,
    marginRight: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  selectedText: {
    fontSize: 12,
    fontFamily: FONTS.AvenirMedium,
    color: COLORS.GREEN,
    fontWeight: '500',
    textTransform: 'uppercase',
  },
});